"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shineAnimation = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
/*
 * Placeholder component is used to show a loading state for components that are loading data.
 *
 * We are planning on introducing a color scheme prop later to have placeholders that work on different backgrounds.
 * Currently it defaults to a color that works well on white backgrounds.
 *
 * It might be convenient to have certain components auto-generate placeholders when a prop on a wrapping component
 * has a "loading" value. Like in https://codepen.io/chris__sev/pen/mdrzYQE
 *
 * The current use case though is for the google calendar integration where it is convenient to just generate placeholders in place of the actual events, since we
 * don't know the count of events before they are loaded.
 *
 * */

var shineAnimation = exports.shineAnimation = (0, _styledComponents.keyframes)(["to{background-position-x:-200%;}"]);
var PlaceholderStyle = _styledComponents.default.div.withConfig({
  displayName: "Placeholder__PlaceholderStyle",
  componentId: "sc-dhd52x-0"
})(["width:", ";height:", ";background:", ";background:linear-gradient( 110deg,", " 8%,", " 18%,", " 33% );border-radius:", ";background-size:200% 100%;animation:1.5s ", " linear infinite;"], function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '100%';
}, _tokens.default.sky.sys.color.background[2], _tokens.default.sky.comp.placeholder.background.default, _tokens.default.sky.comp.placeholder.shimmer.default, _tokens.default.sky.comp.placeholder.background.default, _tokens.default.sky.sys.size.borderradius['2'], shineAnimation);
var Placeholder = function Placeholder(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaceholderStyle, {
    width: width,
    height: height
  });
};
var _default = exports.default = Placeholder;